import React from 'react';
import PropTypes from 'prop-types';
import { Box, DialogContent, Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Trans, useTranslation } from 'react-i18next';
import AmberOutlinedButton from '../../buttons/AmberOutlinedButton';
import AmberPrimaryButton from '../../buttons/AmberPrimaryButton';
import AmberDialog from '../dialogs/AmberDialog';
import AmberDialogActions from '../dialogs/AmberDialogActions';

const useStyles = makeStyles(() => ({
  actionItems: {
    justifyContent: 'flex-end',
  },
  bulletList: {
    paddingLeft: 20,
    margin: 0,
  },
}));

function PaymentTermsDialog(props) {
  const [t] = useTranslation();
  const { open, isSubmitting, onDecision } = props;
  const classes = useStyles();

  return (
    <AmberDialog
      open={open}
      title={t('paymentTermsDialog.title')}
      fullWidth
      maxWidth="sm"
      shouldDisplayCloseButton={false}
      disableEscapeKeyDown
      disableBackdropClick
    >
      <DialogContent>
        <p>{t('paymentTermsDialog.intro')}</p>
        <ul className={classes.bulletList}>
          <li>
            <Trans i18nKey="paymentTermsDialog.bullet1" />
          </li>
          <li>
            <Trans i18nKey="paymentTermsDialog.bullet2" />
          </li>
          <li>
            <Trans i18nKey="paymentTermsDialog.bullet3" />
          </li>
        </ul>
        <p>{t('paymentTermsDialog.note')}</p>
        <Link
          href={t('paymentTermsDialog.amendmentLink')}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('paymentTermsDialog.readAmendment')}
        </Link>
      </DialogContent>
      <AmberDialogActions classes={{ root: classes.actionItems }}>
        <Box>
          <AmberOutlinedButton
            text={t('paymentTermsDialog.reject')}
            onClick={() => onDecision(false)}
            disabled={isSubmitting}
          />
          <AmberPrimaryButton
            text={t('paymentTermsDialog.accept')}
            onClick={() => onDecision(true)}
            disabled={isSubmitting}
          />
        </Box>
      </AmberDialogActions>
    </AmberDialog>
  );
}

PaymentTermsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  onDecision: PropTypes.func.isRequired,
};

export default PaymentTermsDialog;
